/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Import scrollTrigger.js bundle
 */
import { scrollTriggerParallax } from "./scrollTrigger/scrollTrigger-parallax";
import { setTrigger } from "./scrollTrigger/scrollTrigger-trigger";
import { setAddTrigger } from "./scrollTrigger/scrollTrigger-addTrigger";

/**
 * scrollTrigger
 */
const setScrollTrigger = () => {
	scrollTriggerParallax();
	setTrigger();
	setAddTrigger();
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setScrollTrigger };
